module.exports = __webpack_public_path__ + "img/agency-1.4dc994b5.jpg";